import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { useBottomScrollListener } from 'react-bottom-scroll-listener';

import OffersView from './offers-view';
import CastingsHelper from '../../store/castings/action';
import { AdminService } from '../../services/requests';
import {
  castingChangeStatusById,
  moderatedCastingsRemoveById,
  castingsDataAdded,
  changeDataByCastingType,
  updateAllCastings,
  updateModeratedCastings,
  updateArchivedCastings,
  updateDeclinedCastings,
  deleteAllCastingPhoto,
  deleteArchivedCastingPhoto,
  deleteModeratedCastingPhoto,
  allCastingRemoveById,
  archiveCastingRemoveById,
  addCastingToArchiveListFromAll,
  addCastingToArchiveListFromDeclined,
  addCastingToAll,
  addCastingToDeclinedList,
  declinedCastingRemoveById,
} from '../../store/castings';
import { combineDataToUniqueArray } from '../../services/functions';
import { changeValue } from '../../store/statistic';

const INITIAL_CONFIRM_STATE = {
  visible: false,
  castingId: '',
  castingName: '',
  title: '',
  subtitle: '',
  onSubmit: () => {},
};

const OffersContainer = (props) => {
  const [activeTab, setActiveTab] = useState(Number(sessionStorage.getItem('activeTab')) || 0);

  const savedData = JSON.parse(sessionStorage.getItem(renderDataObjectName()));

  const [updateDataLoading, setUpdateDataLoading] = useState(false);
  const [saveChangesLoading, setSaveChangesLoading] = useState(false);
  const [allCastingsPageNumber, setAllCastingsPageNumber] = useState(2);
  const [moderatedCastingsPageNumber, setModeratedCastingsPageNumber] = useState(2);
  const [archivedCastingsPageNumber, setArchivedCastingsPageNumber] = useState(2);
  const [declinedCastingsPageNumber, setDeclinedCastingsPageNumber] = useState(2);
  const [category, setCategory] = useState(savedData?.mainCategory || '');
  const [directionStr, setDirectionStr] = useState(savedData?.direction || 'desc');

  function renderDataObjectName() {
    switch (activeTab) {
      case 0:
        return 'moderatedCastings';
      case 1:
        return 'allCastings';
      case 2:
        return 'archivedCastings';
      case 3:
        return 'declinedCastings';
      default:
        return 'allCastings';
    }
  }

  const [deletePhotoConfirm, setDeletePhotoConfirm] = useState({
    visible: false,
    index: null,
    castingId: '',
    photos: [],
  });
  const [castingActionConfirm, setCastingActionConfirm] = useState({
    ...INITIAL_CONFIRM_STATE,
  });
  const [editModal, setEditModal] = useState({
    visible: false,
    title: '',
    description: '',
    castingId: '',
    hasChanges: false,
  });

  const archiveCasting = async (confirmData) => {
    setSaveChangesLoading(true);
    try {
      await AdminService.addCastingToArchive(confirmData.castingId);
      if (activeTab === 1) {
        props.addCastingToArchiveListFromAll({
          id: confirmData.castingId,
        });
      } else if (activeTab === 3) {
        props.addCastingToArchiveListFromDeclined({
          id: confirmData.castingId,
        });
      }
      props.allCastingRemoveById({
        id: confirmData.castingId,
      });
      props.declinedCastingRemoveById({
        id: confirmData.castingId,
      });
      setSaveChangesLoading(false);
      handleActionsConfirmClose();
    } catch (res) {
      setSaveChangesLoading(false);
      handleActionsConfirmClose();
    }
  };

  const unachiveCasting = async (confirmData) => {
    setSaveChangesLoading(true);
    try {
      await AdminService.resumeCastingFromArchive(confirmData.castingId);
      props.addCastingToAll({
        id: confirmData.castingId,
      });
      props.archiveCastingRemoveById({
        id: confirmData.castingId,
      });
      setSaveChangesLoading(false);
      handleActionsConfirmClose();
    } catch (res) {
      setSaveChangesLoading(false);
      handleActionsConfirmClose();
    }
  };

  const deleteCasting = async (confirmData) => {
    setSaveChangesLoading(true);
    try {
      const res = await AdminService.deleteCasting(confirmData.castingId);
      refreshAction();
      setSaveChangesLoading(false);
      handleActionsConfirmClose();
    } catch (res) {
      setSaveChangesLoading(false);
      handleActionsConfirmClose();
    }
  };

  const confirmValues = {
    'delete': {
      title: 'Confirm deletion',
      subtitle: `Are you sure you want to delete the casting`,
      onSubmit: deleteCasting,
    },
    'archive': {
      title: 'Confirm archiving',
      subtitle: `Are you sure you want to archive the casting`,
      onSubmit: archiveCasting,
    },
    'unarchive': {
      title: 'Confirm unarchiving',
      subtitle: `Are you sure you want to unarchive the casting`,
      onSubmit: unachiveCasting,
    },
  };

  const acceptCasting = async (castingId, param) => {
    setUpdateDataLoading(true);
    try {
      const res = await AdminService.acceptCasting({ castingId });

      if (res === 'OK') {
        props.castingChangeStatusById({
          status: 'accept',
          id: castingId,
        });
        props.moderatedCastingsRemoveById({
          data: props.castings.moderatedCastings.data,
          id: castingId,
        });
        props.declinedCastingRemoveById({
          data: props.castings.declinedCastings.data,
          id: castingId,
        });
        if (param === 'del') {
          props.changeValue({
            key: 'moderatedCastings',
            value: props.statistic.data.moderatedCastings - 1,
          });
        }
        setUpdateDataLoading(false);
      }
    } catch (err) {
      setUpdateDataLoading(false);
    }
  };

  const declineCasting = async (castingId, param) => {
    setUpdateDataLoading(true);
    try {
      const res = await AdminService.declineCasting({ castingId });

      if (res === 'OK') {
        props.castingChangeStatusById({
          status: 'decline',
          id: castingId,
        });
        props.moderatedCastingsRemoveById({
          data: props.castings.moderatedCastings.data,
          id: castingId,
        });
        props.addCastingToDeclinedList({
          id: castingId,
        });
        if (param === 'del') {
          props.changeValue({
            key: 'moderatedCastings',
            value: props.statistic.data.moderatedCastings - 1,
          });
        }
        setUpdateDataLoading(false);
      }
    } catch (err) {
      setUpdateDataLoading(false);
    }
  };

  const renderSphereObject = (id) => {
    for (let i = 0; i < props.categories.data.length; i += 1) {
      if (props.categories.data[i].id === id) {
        return props.categories.data[i];
      }
    }
  };

  const renderCategoriesObject = (sphere, id) => {
    for (let i = 0; i < sphere.children.length; i += 1) {
      if (sphere.children[i].id === id) {
        return sphere.children[i];
      }
    }
  };

  const refreshAction = () => {
    setAllCastingsPageNumber(2);
    setModeratedCastingsPageNumber(2);
    setDeclinedCastingsPageNumber(2);
    setDirectionStr(props.castings[renderDataObjectName()]?.direction || directionStr || 'desc');
    setCategory(props.castings[renderDataObjectName()]?.mainCategory || category || '');
    props.getCastingsInModerated();
    props.getAllCastings();
    props.getArchivedCastings();
    props.getDeclinedCastings();
  };

  const directionRenderStr = () => {
    if (directionStr === 'desc') {
      setDirectionStr('asc');
      return 'asc';
    }
    setDirectionStr('desc');
    return 'desc';
  };

  const sortCastingsList = async (direction, category) => {
    setDirectionStr(direction || 'desc');
    setUpdateDataLoading(true);
    const castingsType = renderDataObjectName();

    if (activeTab === 0) {
      setModeratedCastingsPageNumber(2);
    } else if (activeTab === 1) {
      setAllCastingsPageNumber(2);
    } else if (activeTab === 2) {
      setArchivedCastingsPageNumber(2);
    } else if (activeTab === 3) {
      setDeclinedCastingsPageNumber(2);
    }
    
    try {
      const res = activeTab === 0
        ? await AdminService.getCastingsInModerated(1, direction, category)
        : activeTab === 2
          ? await AdminService.getArchivedCastings(1, direction, category)
          : activeTab === 3
            ? await AdminService.getDeclinedCastings(1, direction, category)
            : await AdminService.getAllCastings(1, direction, category);
      if (res) {
        sessionStorage.setItem(castingsType, JSON.stringify({
          ...res, 
          direction, 
          mainCategory: category
        }));
        props.changeDataByCastingType({ key: castingsType, data: { ...res, direction, mainCategory: category } });
        setUpdateDataLoading(false);
      }
    } catch (err) {
      setUpdateDataLoading(false);
    }
  };

  const handleDeletePhotoConfirmClose = () => {
    showScroll();
    setDeletePhotoConfirm({
      ...deletePhotoConfirm,
      index: null,
      visible: false,
      castingId: '',
      photos: [],
    });
  };

  const handleDeletePhotoConfirmOpen = (index, castingId, photos) => {
    hideScroll();
    setDeletePhotoConfirm({
      ...deletePhotoConfirm,
      index, 
      visible: true,
      castingId,
      photos,
    });
  };

  const handleActionsConfirmClose = () => {
    showScroll();
    setCastingActionConfirm({
      ...INITIAL_CONFIRM_STATE
    });
  };

  const handleActionsConfirmOpen = (castingId, castingName, type) => {
    hideScroll();
    setCastingActionConfirm({
      ...castingActionConfirm,
      visible: true,
      castingId,
      castingName,
      subtitle: `${confirmValues[type].subtitle} "${castingName}"?`,
      title: confirmValues[type].title, 
      onSubmit: confirmValues[type].onSubmit ,
    });
  };

  const handleModalOpen = (castingId, title, description) => {
    hideScroll();
    setEditModal({
      ...editModal,
      visible: true,
      castingId,
      title,
      description,
    });
  };

  const handleModalClose = () => {
    showScroll();
    setEditModal({
      ...editModal,
      visible: false,
      castingId: '',
      title: '',
      description: '',
      hasChanges: false,
    });
  };

  const updateOtherCastingsTypeData = (status) => {
    if (status === 'moderated' && activeTab === 0) {
      props.updateAllCastings({
        title: editModal.title.trim(),
        description: editModal.description.trim(),
        id: editModal.castingId,
      });
    }
    if (status === 'moderated' && activeTab === 1) {
      props.updateModeratedCastings({
        title: editModal.title.trim(),
        description: editModal.description.trim(),
        id: editModal.castingId,
      });
    }
    if (status === 'decline' && activeTab === 1) {
      props.updateDeclinedCastings({
        title: editModal.title.trim(),
        description: editModal.description.trim(),
        id: editModal.castingId,
      });
    }
    if (status === 'decline' && activeTab === 3) {
      props.updateAllCasting({
        title: editModal.title.trim(),
        description: editModal.description.trim(),
        id: editModal.castingId,
      });
    }
  };

  const deleteOtherCastingsTypePhotos = (status, photos) => {
    if (status === 'moderated' && activeTab === 0) {
      props.deleteAllCastingPhoto({
        photos: photos,
        id: deletePhotoConfirm.castingId,
      });
    }
    if (status === 'moderated' && activeTab === 1) {
      props.deleteModeratedCastingPhoto({
        photos: photos,
        id: deletePhotoConfirm.castingId,
      })
    }
  };

  const deletePhoto = async () => {
    setSaveChangesLoading(true);

    try {
      const newPhotosArray = [...deletePhotoConfirm.photos.slice(0, deletePhotoConfirm.index), ...deletePhotoConfirm.photos.slice(deletePhotoConfirm.index + 1)]
      const res = await AdminService.updateCasting(deletePhotoConfirm.castingId, {
        photos: newPhotosArray,
      });
      if (activeTab === 0) {
        props.deleteModeratedCastingPhoto({
          photos: newPhotosArray,
          id: deletePhotoConfirm.castingId,
        })
        deleteOtherCastingsTypePhotos(res.status, newPhotosArray);
      } else if (activeTab === 1) {
          props.deleteAllCastingPhoto({
            photos: newPhotosArray,
            id: deletePhotoConfirm.castingId,
          });
          deleteOtherCastingsTypePhotos(res.status, newPhotosArray);
      } else if (activeTab === 2) {
        props.deleteArchivedCastingPhoto({
          photos: newPhotosArray,
          id: deletePhotoConfirm.castingId,
        });
      }
      handleDeletePhotoConfirmClose();
      setSaveChangesLoading(false);
    } catch (res) {
      setSaveChangesLoading(false);
      handleDeletePhotoConfirmClose();
    }
  };

  const editCasting = async () => {
    setSaveChangesLoading(true);

    try {
      const res = await AdminService.updateCasting(editModal.castingId, {
        title: editModal.title.trim(),
        description: editModal.description.trim(),
      });

      if (activeTab === 0) {
        props.updateModeratedCastings({
          title: editModal.title.trim(),
          description: editModal.description.trim(),
          id: editModal.castingId,
        })
        updateOtherCastingsTypeData(res.status);
      } else if (activeTab === 1) {
          props.updateAllCastings({
            title: editModal.title.trim(),
            description: editModal.description.trim(),
            id: editModal.castingId,
          });
        updateOtherCastingsTypeData(res.status);
      } else if (activeTab === 2) {
        props.updateArchivedCastings({
          title: editModal.title.trim(),
          description: editModal.description.trim(),
          id: editModal.castingId,
        });
      } else if (activeTab === 3) {
        props.updateDeclinedCastings({
          title: editModal.title.trim(),
          description: editModal.description.trim(),
          id: editModal.castingId,
        });
        updateOtherCastingsTypeData(res.status);
      }
      setSaveChangesLoading(false);
      handleModalClose();
    } catch (res) {
      setSaveChangesLoading(false);
      handleModalClose();
    }
  };

  const handleOnDocumentBottom = async () => {
    if (!updateDataLoading && !props.castings.allCastings.loading && !props.castings.moderatedCastings.loading) {
      if (activeTab === 1 && !props.castings.allCastings.last) {
        setAllCastingsPageNumber(allCastingsPageNumber + 1);
        setUpdateDataLoading(true);        
        try {
          const res = await AdminService.getAllCastings(allCastingsPageNumber, directionStr || 'desc', category || '');
          if (res) {
            props.castingsDataAdded({
              key: 'allCastings',
              data: combineDataToUniqueArray(props.castings.allCastings.data, res.data, 'castingId'),
              last: res.last,
              direction: directionStr,
              mainCategory: category,
            });
            setUpdateDataLoading(false);
          }
        } catch (res) {
          setUpdateDataLoading(false);
        }
      }

      if (activeTab === 0 && !props.castings.moderatedCastings.last) {
        setModeratedCastingsPageNumber(moderatedCastingsPageNumber + 1);
        setUpdateDataLoading(true);
        try {
          const res = await AdminService.getCastingsInModerated(moderatedCastingsPageNumber, directionStr || 'desc', category || '');
          if (res) {
            props.castingsDataAdded({
              key: 'moderatedCastings',
              data: combineDataToUniqueArray(props.castings.moderatedCastings.data, res.data, 'castingId'),
              last: res.last,
              direction: directionStr,
              mainCategory: category,
            });
            setUpdateDataLoading(false);
          }
        } catch (res) {
          setUpdateDataLoading(false);
        }
      }

      if (activeTab === 2 && !props.castings.archivedCastings.last) {
        setArchivedCastingsPageNumber(archivedCastingsPageNumber + 1);
        setUpdateDataLoading(true);
        try {
          const res = await AdminService.getArchivedCastings(archivedCastingsPageNumber, directionStr || 'desc', category || '');
          if (res) {
            props.castingsDataAdded({
              key: 'archivedCastings',
              data: combineDataToUniqueArray(props.castings.archivedCastings.data, res.data, 'castingId'),
              last: res.last,
              direction: directionStr,
              mainCategory: category,
            });
            setUpdateDataLoading(false);
          }
        } catch (res) {
          setUpdateDataLoading(false);
        }
      }

      if (activeTab === 3 && !props.castings.declinedCastings.last) {
        setDeclinedCastingsPageNumber(declinedCastingsPageNumber + 1);
        setUpdateDataLoading(true);
        try {
          const res = await AdminService.getDeclinedCastings(declinedCastingsPageNumber, directionStr || 'desc', category || '');
          if (res) {
            props.castingsDataAdded({
              key: 'declinedCastings',
              data: combineDataToUniqueArray(props.castings.declinedCastings.data, res.data, 'castingId'),
              last: res.last,
              direction: directionStr,
              mainCategory: category,
            });
            setUpdateDataLoading(false);
          }
        } catch (res) {
          setUpdateDataLoading(false);
        }
      }
    }
  };

  const hideScroll = () => {
    const marginSize = window.innerWidth - document.documentElement.clientWidth;
    document.body.style.overflow = 'hidden';
    
    if (marginSize) {
      document.documentElement.style.marginRight = marginSize + "px";
    } 
  };

  const showScroll = () => {
    document.documentElement.style.marginRight = "";
    document.body.style.overflow = 'visible';
  };

  useEffect(() => {
    const savedData = JSON.parse(sessionStorage.getItem(renderDataObjectName()))
    setCategory(savedData?.mainCategory || props.castings[renderDataObjectName()].mainCategory || '');
    setDirectionStr(savedData?.direction || props.castings[renderDataObjectName()].direction || 'desc');
    sessionStorage.setItem('activeTab', activeTab);
  }, [activeTab]);

  useBottomScrollListener(handleOnDocumentBottom);

  useEffect(() => {
    if (sessionStorage.getItem(renderDataObjectName())) {
      const savedData = JSON.parse(sessionStorage.getItem(renderDataObjectName()));
      sessionStorage.setItem(renderDataObjectName(), JSON.stringify(savedData));
      props.changeDataByCastingType({ key: renderDataObjectName(), data: { ...savedData } });
    }
  }, []);

  return (
    <OffersView
      moderatedCastings={props.castings.moderatedCastings}
      allCastings={props.castings.allCastings}
      archivedCastings={props.castings.archivedCastings}
      declinedCastings={props.castings.declinedCastings}
      activeTab={activeTab}
      categories={props.categories}
      setActiveTab={setActiveTab}
      renderSphereObject={renderSphereObject}
      renderCategoriesObject={renderCategoriesObject}
      refreshAction={refreshAction}
      acceptCasting={acceptCasting}
      declineCasting={declineCasting}
      updateDataLoading={updateDataLoading}
      category={category}
      setCategory={setCategory}
      directionRenderStr={directionRenderStr}
      sortCastingsList={sortCastingsList}
      renderDataObjectName={renderDataObjectName}
      castings={props.castings}
      directionStr={directionStr}
      deletePhotoConfirm={deletePhotoConfirm}
      handleDeletePhotoConfirmOpen={handleDeletePhotoConfirmOpen}
      handleDeletePhotoConfirmClose={handleDeletePhotoConfirmClose}
      deletePhoto={deletePhoto}
      editModal={editModal}
      setEditModal={setEditModal}
      handleModalClose={handleModalClose}
      handleModalOpen={handleModalOpen}
      editCasting={editCasting}
      deleteCasting={deleteCasting}
      saveChangesLoading={saveChangesLoading}
      archiveCasting={archiveCasting}
      unachiveCasting={unachiveCasting}
      handleActionsConfirmClose={handleActionsConfirmClose}
      handleActionsConfirmOpen={handleActionsConfirmOpen}
      castingActionConfirm={castingActionConfirm}
    />
  );
};

OffersContainer.propTypes = {
  castings: PropTypes.object,
  statistic: PropTypes.object,
  getCastingsInModerated: PropTypes.func,
  castingChangeStatusById: PropTypes.func,
  getAllCastings: PropTypes.func,
  getArchivedCastings: PropTypes.func,
  moderatedCastingsRemoveById: PropTypes.func,
  categories: PropTypes.object,
  castingsDataAdded: PropTypes.func,
  changeValue: PropTypes.func,
  changeDataByCastingType: PropTypes.func,
  deleteCasting: PropTypes.func,
  updateAllCasting: PropTypes.func,
  updateModeratedCastings: PropTypes.func,
  updateArchivedCastings: PropTypes.func,
  updateDeclinedCastings: PropTypes.func,
  deleteAllCastingPhoto: PropTypes.func,
  deleteArchivedCastingPhoto: PropTypes.func,
  deleteModeratedCastingPhoto: PropTypes.func,
  allCastingRemoveById: PropTypes.func,
  archiveCastingRemoveById: PropTypes.func,
  addCastingToArchiveListFromAll: PropTypes.func,
  addCastingToArchiveListFromDeclined: PropTypes.func,
  addCastingToAll: PropTypes.func,
  addCastingToDeclinedList: PropTypes.func,
  declinedCastingRemoveById: PropTypes.func,
};
OffersContainer.defaultProps = {
  castings: {},
  statistic: {},
  getCastingsInModerated: () => {},
  castingChangeStatusById: () => {},
  moderatedCastingsRemoveById: () => {},
  getAllCastings: () => {},
  getArchivedCastings: () => {},
  categories: {},
  castingsDataAdded: () => {},
  changeValue: () => {},
  changeDataByCastingType: () => {},
  deleteCasting: () => {},
  updateAllCastings: () => {},
  updateModeratedCastings: () => {},
  updateArchivedCastings: () => {},
  updateDeclinedCastings: () => {},
  deleteAllCastingPhoto: () => {},
  deleteArchivedCastingPhoto: () => {},
  deleteModeratedCastingPhoto: () => {},
  allCastingRemoveById: () => {},
  archiveCastingRemoveById: () => {},
  addCastingToArchiveListFromAll: () => {},
  addCastingToArchiveListFromDeclined: () => {},
  addCastingToAll: () => {},
  addCastingToDeclinedList: () => {},
  declinedCastingRemoveById: () => {},
};

const mapStateToProps = (store) => ({
  castings: store.castings,
  categories: store.categories,
  statistic: store.statistic,
});

const mapDispatchToProps = (dispatch) => ({
  moderatedCastingsRemoveById: (payload) => dispatch(moderatedCastingsRemoveById(payload)),
  castingChangeStatusById: (payload) => dispatch(castingChangeStatusById(payload)),
  getCastingsInModerated: () => dispatch(CastingsHelper.getCastingsInModerated()),
  getAllCastings: () => dispatch(CastingsHelper.getAllCastings()),
  getArchivedCastings: () => dispatch(CastingsHelper.getArchivedCastings()),
  getDeclinedCastings: () => dispatch(CastingsHelper.getDeclinedCastings()),
  castingsDataAdded: (payload) => dispatch(castingsDataAdded(payload)),
  changeValue: (payload) => dispatch(changeValue(payload)),
  changeDataByCastingType: (payload) => dispatch(changeDataByCastingType(payload)),
  updateAllCastings: (payload) => dispatch(updateAllCastings(payload)),
  updateModeratedCastings: (payload) => dispatch(updateModeratedCastings(payload)),
  updateArchivedCastings: (payload) => dispatch(updateArchivedCastings(payload)),
  updateDeclinedCastings: (payload) => dispatch(updateDeclinedCastings(payload)),
  deleteAllCastingPhoto: (payload) => dispatch(deleteAllCastingPhoto(payload)),
  deleteArchivedCastingPhoto: (payload) => dispatch(deleteArchivedCastingPhoto(payload)),
  deleteModeratedCastingPhoto: (payload) => dispatch(deleteModeratedCastingPhoto(payload)),
  allCastingRemoveById: (payload) => dispatch(allCastingRemoveById(payload)),
  archiveCastingRemoveById: (payload) => dispatch(archiveCastingRemoveById(payload)),
  addCastingToArchiveListFromAll: (payload) => dispatch(addCastingToArchiveListFromAll(payload)),
  addCastingToArchiveListFromDeclined: (payload) => dispatch(addCastingToArchiveListFromDeclined(payload)),
  addCastingToAll: (payload) => dispatch(addCastingToAll(payload)),
  addCastingToDeclinedList: (payload) => dispatch(addCastingToDeclinedList(payload)),
  declinedCastingRemoveById: (payload) => dispatch(declinedCastingRemoveById(payload)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(OffersContainer);
